export const grid = ({ gridColumnGap }) => ({
    display: 'grid',
    gridTemplateColumns: '360px 360px',
    gridColumnGap,
});
